import { useEffect, useState } from "react";
import { Bot, User } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [actor, setActor] = useState("");
  const [clients, setClients] = useState([]);
  const [cid, setCid] = useState("");
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/clients").then(({ data }) => setClients([...new Map(data.map((r) => [r.client_id, r])).values()])); }, []);
  useEffect(() => {
    const params = {};
    if (actor) params.actor = actor;
    if (cid) params.client_id = cid;
    api.get("/audit", { params }).then(({ data }) => setRows(data));
  }, [actor, cid]);
  const sel = "bg-slate-900 border border-border rounded-md px-3 py-2 text-sm";
  return (
    <div className="px-10 py-8 max-w-[1400px]">
      <div className="label-xs mb-1">Compliance</div>
      <h1 className="text-3xl font-extrabold tracking-tight mb-6">Audit log</h1>
      <div className="flex gap-3 mb-4">
        <select data-testid="audit-actor-filter" className={sel} value={actor} onChange={(e) => setActor(e.target.value)}>
          <option value="">AI and human</option><option value="ai">AI only</option><option value="human">Human only</option></select>
        <select data-testid="audit-client-filter" className={sel} value={cid} onChange={(e) => setCid(e.target.value)}>
          <option value="">All clients</option>{clients.map((c) => <option key={c.client_id} value={c.client_id}>{c.name}</option>)}</select>
      </div>
      <div className="rounded-xl border border-border overflow-hidden">
        <table className="w-full text-sm" data-testid="audit-log-table">
          <thead className="bg-slate-900/70 text-left text-[11px] uppercase tracking-wider text-muted-foreground">
            <tr><th className="px-4 py-2.5">When</th><th className="px-4">Who</th><th className="px-4">Type</th><th className="px-4">What</th><th className="px-4">Entity</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-border hover:bg-slate-900/40 cursor-pointer" onClick={() => setOpen(r)} data-testid={`audit-row-${r.id}`}>
                <td className="px-4 py-2 font-mono text-xs text-slate-400 whitespace-nowrap">{new Date(r.at).toLocaleString()}</td>
                <td className="px-4">{r.who}</td>
                <td className="px-4">{r.actor === "ai" ? <span className="inline-flex items-center gap-1 text-xs text-violet-300"><Bot size={12} />AI</span> : <span className="inline-flex items-center gap-1 text-xs text-slate-300"><User size={12} />Human</span>}</td>
                <td className="px-4">{r.action}</td>
                <td className="px-4 text-xs text-slate-500 font-mono">{r.entity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Dialog open={!!open} onOpenChange={() => setOpen(null)}>
        <DialogContent className="max-w-2xl bg-card"><DialogHeader><DialogTitle>{open?.action}</DialogTitle></DialogHeader>
          <pre className="text-xs font-mono whitespace-pre-wrap max-h-[60vh] overflow-auto scroll-thin">{JSON.stringify(open, null, 2)}</pre></DialogContent>
      </Dialog>
    </div>
  );
}
